import BillCard from "./components/HostRentBillCard";
import { useState, useMemo } from "react";
import BillFilter from "./components/HostRentBillFilter";

const mockData = [
  {
    id: 1,
    roomNo: "A-302",
    type: "rent",
    startDate: "2025-01-01",
    endDate: "2025-01-31",
    amount: 3200,
    status: "unpaid",
  },
  {
    id: 2,
    roomNo: "B-110",
    type: "property",
    startDate: "2025-01-01",
    endDate: "2025-03-31",
    amount: 800,
    status: "paid",
  },
];
export default function Payable() {
  const [filters, setFilters] = useState({});

  const filteredData = useMemo(() => {
    return mockData.filter((item) => {
      if (filters.keyword && !item.roomNo.includes(filters.keyword))
        return false;

      if (filters.type && item.type !== filters.type) return false;

      if (filters.status && item.status !== filters.status) return false;

      return true;
    });
  }, [filters]);

  return (
    <>
      <h2 style={{ marginBottom: 12 }}>待收账单</h2>

      <BillFilter
        onChange={(patch) => setFilters((prev) => ({ ...prev, ...patch }))}
      />

      {filteredData.map((item) => (
        <BillCard key={item.id} bill={item} />
      ))}
    </>
  );
}
